var _g, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRemove2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36.875,
    height: 36.875,
    viewBox: "0 0 36.875 36.875",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    stroke: "#00a85b",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36.875,
    height: 36.875,
    rx: 18.438,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 35.875,
    height: 35.875,
    rx: 17.938,
    fill: "none"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.838,16.409a1.681,1.681,0,0,0,1.676,1.676h6.7a1.681,1.681,0,0,0,1.676-1.676V6.352H5.838ZM16.733,3.838H13.8L12.962,3H8.771l-.838.838H5V5.514H16.733Z",
    transform: "translate(7.571 7.895)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemove2);
export default __webpack_public_path__ + "static/media/remove2.96756b3f9757caf1009618ceaa135428.svg";
export { ForwardRef as ReactComponent };